import type { JsonResponse } from '@/types/api/helpers'

const _responseStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
}

export type UploadStatusNormalized = {
  updated_count: number
  created_count: number
  warning_count: number
  error_count: number
  errors: unknown[]
  warnings: unknown[]
  message: string
}

export function handleUploadResponse(
  response:
    | JsonResponse<'/crossroads/mappings/bulk_upload', 'post', 200>
    | unknown,
  setIsLoading: (loading: boolean) => void,
  setStatusResponse: (response: UploadStatusNormalized) => void,
  setUploadStatusModalVisible: (visible: boolean) => void,
  normalizeFunction: ((r: unknown) => UploadStatusNormalized) | null,
  hiddenFileInput: React.RefObject<HTMLInputElement>,
) {
  setIsLoading(false)

  let normalizedResponse: UploadStatusNormalized

  if (normalizeFunction && typeof normalizeFunction === 'function') {
    normalizedResponse = normalizeFunction(response)
  } else {
    const raw = (response as { data?: unknown })?.data ?? response
    const data = raw as Record<string, unknown>

    const updated = Number(
      (data.updated as number | string | undefined) ??
        (data.updated_count as number | string | undefined) ??
        0,
    )
    const created = Number(
      (data.created as number | string | undefined) ??
        (data.created_count as number | string | undefined) ??
        0,
    )
    const errors = Array.isArray(data.errors) ? (data.errors as unknown[]) : []
    const warnings = Array.isArray(data.warnings)
      ? (data.warnings as unknown[])
      : []

    normalizedResponse = {
      updated_count: updated,
      created_count: created,
      warning_count: Number(
        (data.warning_count as number | string | undefined) ?? 0,
      ),
      error_count: Number(
        (data.error_count as number | string | undefined) ?? errors.length,
      ),
      errors,
      warnings,
      message:
        typeof data.message === 'string'
          ? (data.message as string)
          : `Processed ${updated + created} records`,
    }
  }

  setStatusResponse(normalizedResponse)
  setUploadStatusModalVisible(true)

  if (hiddenFileInput.current) {
    hiddenFileInput.current.value = ''
  }
}
